import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CurriculumSessionFormComponent } from '../curriculum-session-form/curriculum-session-form.component';

@Component({
  selector: 'app-curriculum-sessions-editor',
  template: `<app-curriculum-session-form mode="editor" [sessionId]="sessionId"></app-curriculum-session-form>`,
  standalone: true,
  imports: [CurriculumSessionFormComponent],
})
export class CurriculumSessionsEditorComponent {
  private route = inject(ActivatedRoute);

  /** Null for new sessions ('/curriculum-sessions/new'), UUID otherwise. */
  sessionId: string | null = null;

  constructor() {
    this.route.params.subscribe(params => {
      const id = params['sessionId'];
      this.sessionId = id === 'new' ? null : (id ?? null);
    });
  }
}
